import { render, staticRenderFns } from "./FlowsManagement.vue?vue&type=template&id=e21376b0&scoped=true&"
import script from "./flows-management.ts?vue&type=script&lang=ts&"
export * from "./flows-management.ts?vue&type=script&lang=ts&"
import style0 from "./FlowsManagement.vue?vue&type=style&index=0&id=e21376b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21376b0",
  null
  
)

export default component.exports